<div class="container-fluid mt-3 mb-3 theme">
    <div class="row">
        <div class="col-lg-12">
            <div class="d-flex justify-content-end">
                <button class="btn btn-primary" (click)="openNewRequest()">+ New Request</button>
            </div>
        </div>
    </div>
    <div class="card card-body colorborder">
        <div class="col-lg-6">
            <div class="row newReload">
                <div class="pl-4 mb-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                        class="bi bi-arrow-repeat pointer reload" viewBox="0 0 16 16" (click)="getRegMaster()">
                        <title>Reload</title>
                        <path
                            d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                        <path fill-rule="evenodd"
                            d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                    </svg>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <table id="registerMaster" class="table common-table table-bordered table-light nowrap" datatable
                [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                <thead>
                    <tr>
                        <th>Sr. No.</th>
                        <th>Participant Name</th>
                        <!-- <th>Login Name</th> -->
                        <th>Entity Type</th>
                        <th>Access Details</th>
                        <th>Status</th>
                        <th>Created Date</th>
                        <th>Last Modified Date</th>
                        <th>Checker Remark</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of responseData; let i=index">
                        <td>{{i+1}}</td>
                        <td class="pointer"><a (click)="open(data.regID)">{{data.pname}}</a></td>
                        <!-- <td class="nocase">{{data.loginName}}</td> -->
                        <td>{{data.entityType}}</td>
                        <td><i class="fa fa-user pointer usercontrol" aria-hidden="true"
                                (click)="editUserAccessData(data.regID)"></i></td>
                        <td>{{data.status}}</td>
                        <td>{{data.createdDTM | date : 'dd-MM-yyyy HH:mm'}}</td>
                        <td>{{data.modifiedDTM | date : 'dd-MM-yyyy HH:mm'}}</td>
                        <td>{{data.makerComment}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>